export const CommonStyles = {
  anchorLink: 'text-blue300 underline cursor-pointer',
}
